/**
 * @file Currency validator
 * @author Maarten Lensink
 */
import { Validator } from 'breeze-client';
export var NAME_CURRENCY_VALIDATOR = 'currency';
/**
 * This validator validates a currency input
 */
export function CurrencyValidator() {
    var contxt = {};
    var validator = new Validator(NAME_CURRENCY_VALIDATOR, valFunction, contxt);
    return validator;
    function valFunction(value, context) {
        var stringValue = value;
        if (!stringValue) {
            return false;
        }
        var regularExpression = /^\d+[,\.]?\d{0,2}$/;
        return regularExpression.test(stringValue);
    }
}
Validator.messageTemplates[NAME_CURRENCY_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.CURRENCY';
Validator.register(CurrencyValidator());
